import { AddIcon } from "@chakra-ui/icons";
import { Button, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import React from "react";

export type AddQuoteMenuProps = {
  menuItemClickHandler?: (action: AddQuoteMenuActions) => void;
};

export type AddQuoteMenuActions = "RENTAL" | "STF";

function AddQuoteMenu({ menuItemClickHandler }: AddQuoteMenuProps) {
  const handleClick = (action: AddQuoteMenuActions) => {
    if (menuItemClickHandler) {
      menuItemClickHandler(action);
    }
  };

  return (
    <Menu placement="bottom-end">
      <MenuButton
        as={Button}
        variant="brand"
        leftIcon={<AddIcon boxSize="12px" />}
      >
        New Quote
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => handleClick("STF")}>Short Term Quote</MenuItem>
        <MenuItem onClick={() => handleClick("RENTAL")}>Rental Quote</MenuItem>
      </MenuList>
    </Menu>
  );
}

export default AddQuoteMenu;
